import { PaneemType } from "../../constants";
import type { IActionButtonsProps } from "../../types";
import { Button } from "@mui/material";

export default function ActionButtons(props: IActionButtonsProps) {
  const { startText, statusText, handleCheckUserStatus, paneemType } = props;

  return (
    <>
      {paneemType === PaneemType.paneem ? (
        <>
          <Button type="submit" fullWidth variant="contained" color="primary" sx={{ mb: 3 }}>
            {startText}
          </Button>

          <Button fullWidth variant="contained" color="info" onClick={() => handleCheckUserStatus()}>
            {statusText}
          </Button>
        </>
      ) : (
        <Button fullWidth variant="contained" color="info" onClick={() => handleCheckUserStatus()}>
          {statusText}
        </Button>
      )}
    </>
  );
}
